import authRequest from '../authRequest';
import NoteTemplatePresenter from '../../presenters/NoteTemplatePresenter';

const createNoteTemplate = async (name, content = null, file = null) => {
  try {
    // Validate required parameter
    if (!name) {
      throw new Error('Template name is required');
    }

    // Validate that either content or file is provided
    if (!content && !file) {
      throw new Error('Either content or file must be provided');
    }

    // Prepare request data
    let requestData;

    if (file) {
      // If file is provided, use FormData
      requestData = new FormData();
      requestData.append('note_template[name]', name);
      requestData.append('note_template[file]', file);
      if (content) {
        requestData.append('note_template[content]', content);
      }
    } else {
      // If only content is provided, use JSON
      requestData = {
        note_template: {
          name: name,
          content: content
        }
      };
    }

    const response = await authRequest('/note_templates', {
      method: 'POST',
      data: requestData
    });
    
    if (response.status === 200) {
      return new NoteTemplatePresenter(response.data);
    } else {
      throw new Error('Failed to create note template');
    }

  } catch (error) {
    console.error('Error creating note template:', error);
    throw error;
  }
};

export default createNoteTemplate;
